export default "__VITE_ASSET__D5yrEqt4__"